module.exports = __webpack_public_path__ + "media/images/brands/marque-opi-6e3c328b81ad53f178b4ff3ae5cbddb2.jpg";